import ClientMealAssignments from './ClientMealAssignments';

export default ClientMealAssignments;
